import { EditLabelDialog} from '@tableau/catalog-ui-temp';
import React from 'react';
import { call, put } from 'redux-saga/effects';

import { SetSensitiveOrWarningLabelValueAction } from '~src/catalog/actions/labels/SetSensitiveOrWarningLabelValueAction';
import { CatalogProviders } from '~src/catalog/CatalogProviders';
import { getItemsWithCorrectLuids } from '~src/Collections/sagas/CollectionSagas';
import { ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { reloadSpaceIfUpdatingCurrentSpace } from '~src/spacesPlatform/sagas/content/RefreshContentSagas';

import { requestFailed } from '../../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../../codegen/Localize';


export function* handleSetLabelValue(action: SetSensitiveOrWarningLabelValueAction) {
  try {
    yield call(openLabelValueDialog, action);
    const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, [action.item]);
    if (!maybeReloaded) {
      yield put(requestSpaceContents());
    }
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function openLabelValueDialog(action: SetSensitiveOrWarningLabelValueAction) {
  const itemWithCorrectLuid = getItemsWithCorrectLuids([action.item])[0];
  const { contentType } = itemWithCorrectLuid;

  if (contentType !== 'labelValue') {
    throw new Error(` user cannot change label value contents on ${contentType}.`);
  }

  return ReactModalService.openCustom(({ close }) => {
    return (
      <CatalogProviders>
        <EditLabelDialog
        close={close}
        dismiss={close}
        labelValueName={action.item.value}
        categoryName={action.item.category}
        description={action.item.labelDescription}
        elevatedDefault={action.item.visiblity}
        builtIn={action.item.builtIn}
        />
      </CatalogProviders>
    );
  }).result;
}
